export const ANIMAL_DATA = {
  // --- Group 0. 전설의 동물 (LEGENDARY) ---
  "LEVIATHAN": {
    isLegendary: true,
    name: "심해의 레비아탄",
    title: "기록되지 않은 신화",
    desc: "당신의 사고는 빛조차 닿지 않는 심해만큼이나 깊습니다. 대중의 시선에 연연하지 않으며, 오직 본질만을 꿰뚫어 봅니다.",
    motto: "당신이 침묵할 때 세상은 가장 크게 요동칩니다.",
    advice: "수면 위로 올라와 숨을 쉬는 법을 잊지 마세요. 당신의 지혜는 공유될 때 비로소 신화가 됩니다.",
    color: "#001F3F",
    img: "/images/animals/r1.jpg",
    tags: ["심연의_지성", "본질주의자", "고요한_힘"]
  },
  "PHOENIX": {
    isLegendary: true,
    name: "화염을 품은 봉황",
    title: "영원히 타오르는 의지",
    desc: "당신은 멈추지 않는 폭풍이자, 스스로를 태워 길을 밝히는 불꽃입니다. 실패를 두려워하지 않고 매번 더 강하게 일어납니다.",
    motto: "거세게 타오르는 불꽃은 결코 꺼지지 않습니다.",
    advice: "모든 것을 태워버리지 않도록 주의하세요. 때로는 온기만으로도 충분합니다.",
    color: "#FF4136",
    img: "/images/animals/r2.jpg",
    tags: ["불굴의_의지", "열정", "부활"]
  },
  "HAETAE": {
    isLegendary: true,
    name: "구름 위의 해태",
    title: "완벽한 조화의 수호자",
    desc: "당신은 우주의 균형 그 자체이며, 어느 한쪽으로 치우치지 않습니다. 냉철하면서도 따뜻하고, 용맹하면서도 신중합니다.",
    motto: "편견 없는 눈만이 진실을 봅니다.",
    advice: "중도를 지키는 일은 외로운 법입니다. 가끔은 감정이 이끄는 대로 움직여도 괜찮습니다.",
    color: "#FFD700",
    img: "/images/animals/r3.jpg",
    tags: ["균형", "정의", "영물"]
  },
  "UNICORN": {
    isLegendary: true,
    name: "시공간의 유니콘",
    title: "순수한 영혼의 개척자",
    desc: "당신은 세상의 규칙이 아닌 당신만의 주파수로 살아갑니다. 누구도 흉내 낼 수 없는 독보적인 아우라를 지니고 있습니다.",
    motto: "당신의 존재 자체가 누군가에게는 꿈입니다.",
    advice: "당신을 이해하지 못하는 세상에 낙담하지 마세요. 당신의 뿔은 가치를 알아보는 자에게만 빛납니다.",
    color: "#F012BE",
    img: "/images/animals/r4.jpg",
    tags: ["독창성", "순수함", "아우라"]
  },

  // --- Group 1. 열정적인 활동가 (E_ 로 시작) ---
  "E_S": {
    name: "리트리버",
    title: "은퇴한 파티 플래너",
    desc: "낯선 사람과도 5분 만에 친구가 되는 마법 같은 친화력의 소유자입니다.",
    motto: "내 사전엔 모르는 사람이란 없다.",
    advice: "모두에게 좋은 사람이 되려다 당신의 마음이 텅 빌 수 있어요. 가끔은 거절해도 괜찮습니다.",
    color: "#FFDC00",
    img: "/images/animals/r5.jpg",
    tags: ["친화력", "마당발", "긍정"]
  },
  "E_I": {
    name: "보더콜리",
    title: "투자 유치 전문 CEO",
    desc: "열정적이면서도 머릿속엔 항상 다음 단계의 계산이 서 있는 전략가입니다.",
    motto: "열정은 차갑게, 실행은 뜨겁게.",
    advice: "완벽한 전략보다 중요한 건 동료의 마음입니다. 가끔은 계산기를 내려놓고 감정에 귀 기울이세요.",
    color: "#111111",
    img: "/images/animals/r6.jpg",
    tags: ["전략가", "효율", "천재적"]
  },
  "E_W": {
    name: "야생마",
    title: "브레이크 고장 난 질주마",
    desc: "일단 마음먹으면 끝을 봐야 직성이 풀리는, 멈추지 않는 도전자입니다.",
    motto: "멈추는 법을 잊은 지 오래다.",
    advice: "혼자서 모든 걸 짊어지지 마세요. 가끔은 누군가에게 기댈 때 예상치 못한 시너지가 폭발합니다.",
    color: "#85144b",
    img: "/images/animals/r7.jpg",
    tags: ["도전", "질주", "에너지"]
  },
  "E_E": {
    name: "미어캣",
    title: "건전지 100개 씹어먹은 인싸",
    desc: "잠시도 가만히 있지 못하며, 세상 모든 일에 참견해야 하는 에너자이저입니다.",
    motto: "세상의 모든 소식은 나를 거친다.",
    advice: "모든 소식에 귀를 기울일 필요는 없습니다. 때로는 고요함 속에서 당신의 내면 소리를 들어보세요.",
    color: "#FF851B",
    img: "/images/animals/r8.jpg",
    tags: ["에너자이저", "정보통", "호기심"]
  },
  "E_S2": {
    name: "돌고래",
    title: "무대 난입에 성공한 관종",
    desc: "모두를 즐겁게 만드는 천부적인 재능과 긍정 에너지를 가진 분위기 메이커입니다.",
    motto: "인생은 하나의 거대한 쇼다.",
    advice: "박수가 멈춘 뒤의 공허함을 두려워하지 마세요. 당신은 존재 자체만으로도 충분히 빛납니다.",
    color: "#7FDBFF",
    img: "/images/animals/r9.jpg",
    tags: ["분위기메이커", "스타성", "행복"]
  },
  "E_I2": {
    name: "앵무새",
    title: "웅변 학원 원장님",
    desc: "화려한 언변으로 사람들을 설득하고 자신의 페이스로 끌어들이는 능력자입니다.",
    motto: "내 말 한마디로 세상을 움직인다.",
    advice: "말의 화려함보다 침묵의 무게가 더 큰 설득력을 가질 때가 있습니다. 경청의 힘을 믿어보세요.",
    color: "#2ECC40",
    img: "/images/animals/r10.jpg",
    tags: ["언변가", "설득", "매력"]
  },
  "E_W2": {
    name: "산양",
    title: "익스트림 스포츠 마니아",
    desc: "위험할수록 아드레날린을 느끼며 남들이 가지 않는 험난한 길을 즐깁니다.",
    motto: "절벽 끝에서 진정한 나를 만난다.",
    advice: "아찔한 절벽 끝도 좋지만, 가끔은 평지의 안락함을 누리며 발 아래의 꽃을 감상해 보세요.",
    color: "#AAAAAA",
    img: "/images/animals/r11.jpg",
    tags: ["모험", "스릴", "독고다이"]
  },
  "E_Mix": {
    name: "치타",
    title: "사바나의 스피드 레이서",
    desc: "누구보다 빠르게 상황에 적응하고 목표를 낚아채는 효율적 활동가입니다.",
    motto: "속도가 곧 실력이다.",
    advice: "속도가 모든 걸 해결해주진 않습니다. 방향이 틀렸다면 잠시 멈춰 서서 별을 바라보세요.",
    color: "#FFD700",
    img: "/images/animals/r12.jpg",
    tags: ["스피드", "효율", "사냥꾼"]
  },

  // --- Group 2. 지성적 신중파 (I_ 로 시작) ---
  "I_S": {
    name: "고양이",
    title: "낯가리는 집사 지망생",
    desc: "친해지는 데 시간이 걸리지만, 한 번 마음을 열면 깊은 애정을 주는 타입입니다.",
    motto: "선택된 사람만이 내 애정을 받는다.",
    advice: "당신의 성벽 안으로 누군가를 초대하는 것을 너무 두려워 마세요. 의외의 온기를 만날지도 모릅니다.",
    color: "#FFCEF3",
    img: "/images/animals/r13.jpg",
    tags: ["츤데레", "신중함", "집사"]
  },
  "I_E": {
    name: "나무늘보",
    title: "사실은 내적 관종",
    desc: "겉으론 느긋해 보여도 속으로는 남들이 나를 어떻게 볼지 고민하는 타입입니다.",
    motto: "느리지만 모든 것을 지켜보고 있다.",
    advice: "속도는 느려도 괜찮지만, 방향만큼은 스스로 결정하세요. 남들의 시선보다 당신의 속도가 소중합니다.",
    color: "#B10DC9",
    img: "/images/animals/r14.jpg",
    tags: ["느긋함", "내적관종", "평화주의"]
  },
  "I_W": {
    name: "눈표범",
    title: "설산의 고독한 철학자",
    desc: "타인의 간섭을 가장 싫어하며, 혼자만의 완벽한 성역을 구축하고 삽니다.",
    motto: "고독은 나를 더 단단하게 만든다.",
    advice: "혼자서 모든 걸 짊어지지 마세요. 가끔은 누군가에게 기댈 때 예상치 못한 시너지가 폭발합니다.",
    color: "#DDDDDD",
    img: "/images/animals/r15.jpg",
    tags: ["고독", "철학", "강인함"]
  },
  "I_I": {
    name: "부엉이",
    title: "밤을 지새우는 분석가",
    desc: "모든 정보가 수집되기 전까지는 움직이지 않는 완벽주의 전략가입니다.",
    motto: "완벽하지 않으면 움직이지 않는다.",
    advice: "분석이 끝나기를 기다리다 기회를 놓칠 수 있습니다. 때로는 70%의 확신만으로도 충분합니다.",
    color: "#001f3f",
    img: "/images/animals/r16.jpg",
    tags: ["분석", "지혜", "완벽주의"]
  },
  "I_S2": {
    name: "코끼리",
    title: "숲속의 비밀 상담소장",
    desc: "조용히 타인의 이야기를 들어주며 묵직한 위로를 건네는 든든한 조력자입니다.",
    motto: "당신의 슬픔을 내가 들어줄게요.",
    advice: "타인의 고민을 담아주느라 당신의 그릇이 넘치고 있네요. 당신의 슬픔도 누군가에게 나누어 주세요.",
    color: "#0074D9",
    img: "/images/animals/r17.jpg",
    tags: ["공감", "조력자", "포용"]
  },
  "I_E2": {
    name: "거북이",
    title: "야근 요정 공무원",
    desc: "화려하진 않지만 지치지 않는 인내심으로 결국 결승선에 먼저 도착합니다.",
    motto: "포기하지 않는 자가 결국 승리한다.",
    advice: "성실함은 최고의 무기지만, 가끔은 지름길로 가보는 모험이 당신의 세계를 넓혀줄 것입니다.",
    color: "#2ECC40",
    img: "/images/animals/r18.jpg",
    tags: ["성실", "인내", "꾸준함"]
  },
  "I_W2": {
    name: "너구리",
    title: "코딩하는 천재 공학자",
    desc: "호기심이 많고 영리하며, 복잡한 문제를 창의적으로 해결하는 능력자입니다.",
    motto: "복잡한 문제일수록 즐겁다.",
    advice: "머릿속의 설계도를 현실로 꺼내 놓으세요. 생각만으로는 세상을 바꿀 수 없습니다.",
    color: "#39CCCC",
    img: "/images/animals/r19.jpg",
    tags: ["천재성", "문제해결", "호기심"]
  },
  "I_Mix": {
    name: "펭귄",
    title: "질서 정연한 서재지기",
    desc: "정해진 규칙과 루틴 안에서 최강의 안정을 느끼는 원칙 중심주의자입니다.",
    motto: "질서 속에 진정한 자유가 있다.",
    advice: "규칙 밖의 세상이 반드시 위험한 건 아닙니다. 가끔은 무질서함 속에서 새로운 창의성을 발견해 보세요.",
    color: "#FFFFFF",
    img: "/images/animals/r20.jpg",
    tags: ["질서", "원칙", "안정"]
  },
  // --- 이후 21~36번 데이터는 같은 형식으로 이어집니다 ---
  // --- Group 3. 야생의 개척자 (W_ 로 시작) ---
  "W_E": {
    name: "독수리",
    title: "대륙 횡단 탐험가",
    desc: "세세한 디테일보다는 큰 그림을 보며 과감한 결단을 내리는 야심가입니다.",
    motto: "높은 곳에서 세상을 굽어보라.",
    advice: "높은 곳에서 볼 때는 보이지 않는 작은 것들의 가치를 잊지 마세요. 디테일이 승부를 가를 때가 있습니다.",
    color: "#F012BE",
    img: "/images/animals/r21.jpg",
    tags: ["비전", "야심가", "대담함"]
  },
  "W_S": {
    name: "몽구스",
    title: "의리에 살고 의리에 죽는 전사",
    desc: "자신의 사람이라 믿으면 앞뒤 재지 않고 지키기 위해 뛰어드는 의리파 전사입니다.",
    motto: "내 사람을 건드리는 자는 용서치 않는다.",
    advice: "적을 만들기보다 내 편을 안전하게 지키는 유연한 전략도 때로는 필요합니다.",
    color: "#FF4136",
    img: "/images/animals/r22.jpg",
    tags: ["의리", "충성", "용맹"]
  },
  "W_I": {
    name: "늑대",
    title: "밤을 기다리는 사냥꾼",
    desc: "기회를 집요하게 노리다가 단 한 번의 움직임으로 승부를 보는 냉철한 승부사입니다.",
    motto: "승부는 단 한 번의 움직임으로 결정된다.",
    advice: "혼자 사냥할 때보다 무리와 힘을 합칠 때 당신의 진가는 더욱 거대해질 것입니다.",
    color: "#111111",
    img: "/images/animals/r23.jpg",
    tags: ["승부사", "집요함", "카리스마"]
  },
  "W_W": {
    name: "재규어",
    title: "정글의 고독한 포식자",
    desc: "누구의 도움 없이 오직 자신의 힘만으로 정점에 오르려는 강인한 개척자입니다.",
    motto: "나의 힘만이 나를 증명한다.",
    advice: "정상은 춥고 고독합니다. 가끔은 당신의 곁을 온기로 채워줄 동료를 찾아보세요.",
    color: "#3D9970",
    img: "/images/animals/r24.jpg",
    tags: ["개척자", "강인함", "독립심"]
  },
  "W_E2": {
    name: "갈매기",
    title: "폭풍을 즐기는 항해사",
    desc: "거친 환경일수록 생존 본능이 깨어나며 역경 속에서 더 빛을 발하는 타입입니다.",
    motto: "거친 파도가 나를 더 강하게 만든다.",
    advice: "생존을 위한 사투도 좋지만, 가끔은 평온한 바다에서 느긋하게 파도를 즐겨보세요.",
    color: "#DDDDDD",
    img: "/images/animals/r25.jpg",
    tags: ["회복탄력성", "강인함", "생존왕"]
  },
  "W_S2": {
    name: "들개",
    title: "자유로운 영혼의 방랑자",
    desc: "정형화된 삶을 거부하고 마음이 이끄는 곳이라면 어디든 떠도는 야생의 자유를 가졌습니다.",
    motto: "길이 없으면 만들어서 가고, 마음이 가면 그곳이 길이다.",
    advice: "방랑의 끝에 당신을 기다리는 안식처를 하나쯤 만들어 두는 것도 진정한 자유입니다.",
    color: "#FF851B",
    img: "/images/animals/r26.jpg",
    tags: ["자유", "방랑자", "야생성"]
  },
  "W_I2": {
    name: "여우",
    title: "잃어버린 유적 가이드",
    desc: "위기의 순간에 가장 빛나는 기지와 지능을 가진 영특한 생존 전문가입니다.",
    motto: "힘보다 지혜가 더 날카로운 무기다.",
    advice: "영리한 잔머리보다 진심 어린 소통이 때로는 더 큰 문을 열어줄 수 있습니다.",
    color: "#FFD700",
    img: "/images/animals/r27.jpg",
    tags: ["기지", "생존전문가", "영리함"]
  },
  "W_Mix": {
    name: "곰",
    title: "꿀단지 수색 탱크",
    desc: "단순하고 명확한 목표를 향해 주변 눈치 보지 않고 밀고 나가는 엄청난 추진력의 소유자입니다.",
    motto: "목표가 정해지면 뒤는 돌아보지 않는다.",
    advice: "목표를 향해 달릴 때 당신이 무심코 밟고 지나가는 주변의 소중한 가치들도 살펴보세요.",
    color: "#85144b",
    img: "/images/animals/r28.jpg",
    tags: ["추진력", "파워", "단순함"]
  },

  // --- Group 4. 따뜻한 수호자 (S_ 로 시작) ---
  "S_E": {
    name: "캥거루",
    title: "근육질 돌봄 선생님",
    desc: "주변 사람들을 돌보기 위해 부지런히 움직이는 열정적인 수호자입니다.",
    motto: "나의 힘은 소중한 이들을 지키기 위해 존재한다.",
    advice: "남을 돌보는 일에 너무 열중해 정작 당신의 주머니 속 소중한 꿈을 잊고 있지는 않나요?",
    color: "#FF851B",
    img: "/images/animals/r29.jpg",
    tags: ["보호자", "열정", "책임감"]
  },
  "S_I": {
    name: "백조",
    title: "평화로운 호수의 우아한 노력파",
    desc: "겉으로는 평온해 보이지만, 그 평화를 유지하기 위해 수면 아래서 끊임없이 발버둥 치는 노력파입니다.",
    motto: "우아함 뒤에는 보이지 않는 헌신이 있다.",
    advice: "물 아래의 힘겨운 발버둥을 가끔은 사람들에게 보여주세요. 당신의 인간미가 더 큰 사랑을 부를 것입니다.",
    color: "#FFFFFF",
    img: "/images/animals/r30.jpg",
    tags: ["노력파", "평화", "우아함"]
  },
  "S_W": {
    name: "사자",
    title: "무리를 지키는 사자왕",
    desc: "자신의 영역과 소중한 이들을 지키기 위해 기꺼이 짐을 짊어지는 책임감 있는 리더입니다.",
    motto: "왕관의 무게를 견디는 자가 무리를 지킨다.",
    advice: "사자의 포효보다 따뜻한 포용이 더 크고 단단한 무리를 만드는 법입니다.",
    color: "#FFD700",
    img: "/images/animals/r31.jpg",
    tags: ["리더십", "책임감", "가디언"]
  },
  "S_S": {
    name: "쿼카",
    title: "세상을 치유하는 힐링 마스터",
    desc: "존재만으로도 갈등을 녹이고 주변에 웃음을 전염시키는 긍정의 아이콘입니다.",
    motto: "나의 미소가 세상을 바꿀 수 있다고 믿는다.",
    advice: "항상 웃어주지 않아도 당신은 충분히 가치 있습니다. 슬플 때는 마음껏 울어도 괜찮습니다.",
    color: "#FFCEF3",
    img: "/images/animals/r32.jpg",
    tags: ["행복", "치유", "미소"]
  },
  "S_E2": {
    name: "물개",
    title: "재능 많은 탭댄서",
    desc: "칭찬과 박수를 먹고 자라며, 사람들에게 즐거움을 주는 것에서 가장 큰 행복을 느낍니다.",
    motto: "즐거움은 나누면 배가 된다.",
    advice: "관객의 환호가 없을 때도 당신의 춤은 그 자체로 충분히 아름답다는 것을 잊지 마세요.",
    color: "#0074D9",
    img: "/images/animals/r33.jpg",
    tags: ["재능꾼", "쇼맨십", "긍정"]
  },
  "S_I2": {
    name: "판다",
    title: "도서관 지기 힐러",
    desc: "말수는 적지만 곁에 있는 것만으로도 사람들에게 포근함과 정서적 안정을 주는 존재입니다.",
    motto: "느림 속에 진정한 안식이 있다.",
    advice: "때로는 느릿한 걸음에서 벗어나 세상을 향해 크게 달려보고 싶을 때는 주저 말고 뛰쳐나가 보세요.",
    color: "#111111",
    img: "/images/animals/r34.jpg",
    tags: ["휴식", "포근함", "안식"]
  },
  "S_W2": {
    name: "고릴라",
    title: "밀림의 든든한 가디언",
    desc: "무뚝뚝해 보여도 결정적인 순간에 모두의 기둥이 되어주는 묵직한 정신적 지주입니다.",
    motto: "침묵 속에 가장 강한 기둥이 있다.",
    advice: "당신의 거대한 등 뒤에도 때로는 기댈 수 있는 따뜻한 손길이 필요하다는 것을 인정하세요.",
    color: "#001f3f",
    img: "/images/animals/r35.jpg",
    tags: ["정신적지주", "든든함", "가디언"]
  },
  "S_Mix": {
    name: "사슴",
    title: "봄날 햇살 아래의 순수함",
    desc: "맑은 샘물처럼 투명한 감수성을 지닌 당신은 존재만으로 주변의 긴장을 녹여내는 따뜻한 사람입니다.",
    motto: "순수함은 세상에서 가장 강력한 힘이다.",
    advice: "세상의 거친 소음으로부터 당신의 연약하고 아름다운 마음을 잘 지켜내길 바랍니다.",
    color: "#F7E7CE",
    img: "/images/animals/r36.jpg",
    tags: ["감수성", "맑은영혼", "봄날의햇살"]
  }
};